/**
 * excelUtils.js — CSV download helper (Excel opens .csv natively).
 * No external dependencies.
 */

/** Escape a cell value for CSV: wrap in quotes if it contains comma/quote/newline */
function csvCell(val) {
  const s = val == null ? '' : String(val);
  if (s.includes(',') || s.includes('"') || s.includes('\n')) {
    return '"' + s.replace(/"/g, '""') + '"';
  }
  return s;
}

/**
 * Download rows as a .csv file.
 * @param {string[]}    headers  — column header labels
 * @param {any[][]}     rows     — 2-D array of cell values (parallel to headers)
 * @param {string}      filename — e.g. "tickets-2026-05-01"
 */
export function downloadCSV(headers, rows, filename = 'export') {
  const lines = [
    headers.map(csvCell).join(','),
    ...rows.map(row => row.map(csvCell).join(',')),
  ];
  const blob = new Blob(['\uFEFF' + lines.join('\r\n')], { type: 'text/csv;charset=utf-8;' });
  const url  = URL.createObjectURL(blob);
  const a    = document.createElement('a');
  a.href     = url;
  a.download = `${filename}.csv`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}
